import I18n from 'i18n-js';
I18n.translations || (I18n.translations = {});
I18n.translations["es"] = I18n.extend((I18n.translations["es"] || {}), {
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "La validación falló: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "No se puede eliminar el registro porque existen %{record} dependientes",
          "has_one": "No se puede eliminar el registro porque existe un %{record} dependiente"
        }
      }
    }
  },
  "check_reservation": {
    "code_text": "Chequear reserva",
    "no_search_params": "No se especificó ningún criterio de búsqueda",
    "reference_incorrect": "No hay ninguna reserva  con No. de referencia: %{reference}",
    "reference_not_found": "No pudimos validar ninguna reserva con No. de referencia: %{reference}, para el Email: %{email}"
  },
  "date": {
    "abbr_day_names": [
      "dom",
      "lun",
      "mar",
      "mié",
      "jue",
      "vie",
      "sáb"
    ],
    "abbr_month_names": [
      null,
      "ene",
      "feb",
      "mar",
      "abr",
      "may",
      "jun",
      "jul",
      "ago",
      "sep",
      "oct",
      "nov",
      "dic"
    ],
    "day_names": [
      "domingo",
      "lunes",
      "martes",
      "miércoles",
      "jueves",
      "viernes",
      "sábado"
    ],
    "formats": {
      "default": "%-d/%-m/%Y",
      "long": "%-d de %B de %Y",
      "short": "%-d de %b"
    },
    "month_names": [
      null,
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre"
    ],
    "order": [
      "day",
      "month",
      "year"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "alrededor de 1 hora",
        "other": "alrededor de %{count} horas"
      },
      "about_x_months": {
        "one": "alrededor de 1 mes",
        "other": "alrededor de %{count} meses"
      },
      "about_x_years": {
        "one": "alrededor de 1 año",
        "other": "alrededor de %{count} años"
      },
      "almost_x_years": {
        "one": "casi 1 año",
        "other": "casi %{count} años"
      },
      "half_a_minute": "medio minuto",
      "less_than_x_minutes": {
        "one": "menos de 1 minuto",
        "other": "menos de %{count} minutos"
      },
      "less_than_x_seconds": {
        "one": "menos de 1 segundo",
        "other": "menos de %{count} segundos"
      },
      "over_x_years": {
        "one": "más de 1 año",
        "other": "más de %{count} años"
      },
      "x_days": {
        "one": "1 día",
        "other": "%{count} días"
      },
      "x_minutes": {
        "one": "1 minuto",
        "other": "%{count} minutos"
      },
      "x_months": {
        "one": "1 mes",
        "other": "%{count} meses"
      },
      "x_seconds": {
        "one": "1 segundo",
        "other": "%{count} segundos"
      },
      "x_years": {
        "one": "1 año",
        "other": "%{count} años"
      }
    },
    "prompts": {
      "day": "Día",
      "hour": "Hora",
      "minute": "Minuto",
      "month": "Mes",
      "second": "Segundo",
      "year": "Año"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "debe ser aceptado",
      "blank": "no puede estar en blanco",
      "confirmation": "no coincide",
      "empty": "no puede estar vacío",
      "equal_to": "debe ser igual a %{count}",
      "even": "debe ser par",
      "exclusion": "está reservado",
      "greater_than": "debe ser mayor que %{count}",
      "greater_than_or_equal_to": "debe ser mayor que o igual a %{count}",
      "inclusion": "no está incluido en la lista",
      "invalid": "no es válido",
      "less_than": "debe ser menor que %{count}",
      "less_than_or_equal_to": "debe ser menor que o igual a %{count}",
      "model_invalid": "La validación falló: %{errors}",
      "not_a_number": "no es un número",
      "not_an_integer": "debe ser un entero",
      "odd": "debe ser impar",
      "other_than": "debe ser distinto de %{count}",
      "present": "debe estar en blanco",
      "required": "debe existir",
      "taken": "ya está en uso",
      "too_long": {
        "one": "es demasiado largo (1 carácter máximo)",
        "other": "es demasiado largo (%{count} caracteres máximo)"
      },
      "too_short": {
        "one": "es demasiado corto (1 carácter mínimo)",
        "other": "es demasiado corto (%{count} caracteres mínimo)"
      },
      "wrong_length": {
        "one": "no tiene la longitud correcta (1 carácter exactos)",
        "other": "no tiene la longitud correcta (%{count} caracteres exactos)"
      }
    },
    "template": {
      "body": "Se encontraron problemas con los siguientes campos:",
      "header": {
        "one": "No se pudo guardar este/a %{model} porque se encontró 1 error",
        "other": "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
      }
    }
  },
  "errors_page": {
    "internal_server_error": "al parecer hubo un error en el servidor, inténtelo más tarde",
    "locked": "Este recurso está bloqueado.",
    "not_accepted": "Hemos detectado que esta usando un servidor proxy para acceder a nuestra web",
    "not_found": "La página solicitada no existe o puede que el enlace este roto",
    "unprocessable_entity": "La acción no se pudo procesar correctamente debido a que se proporcionaron datos no válidos"
  },
  "faker": {
    "address": {
      "building_number": [
        " s/n.",
        ", #",
        ", ##",
        " #",
        " ##"
      ],
      "city": [
        "#{city_prefix}"
      ],
      "city_prefix": [
        "Parla",
        "Telde",
        "Baracaldo",
        "San Fernando",
        "Torrevieja",
        "Lugo",
        "Santiago de Compostela",
        "Gerona",
        "Cáceres",
        "Lorca",
        "Coslada",
        "Talavera de la Reina",
        "El Puerto de Santa María",
        "Cornellá de Llobregat",
        "Avilés",
        "Palencia",
        "Gecho",
        "Orihuela",
        "Pontevedra",
        "Pozuelo de Alarcón",
        "Toledo",
        "El Ejido",
        "Guadalajara",
        "Gandía",
        "Ceuta",
        "Ferrol",
        "Chiclana de la Frontera",
        "Manresa",
        "Roquetas de Mar",
        "Ciudad Real",
        "Rubí",
        "Benidorm",
        "San Sebastían de los Reyes",
        "Ponferrada",
        "Zamora",
        "Alcalá de Guadaira",
        "Fuengirola",
        "Mijas",
        "Sanlúcar de Barrameda",
        "La Línea de la Concepción",
        "Majadahonda",
        "Sagunto",
        "El Prat de LLobregat",
        "Viladecans",
        "Linares",
        "Alcoy",
        "Irún",
        "Estepona",
        "Torremolinos",
        "Rivas-Vaciamadrid",
        "Molina de Segura",
        "Paterna",
        "Granollers",
        "Santa Lucía de Tirajana",
        "Motril",
        "Cerdañola del Vallés",
        "Arrecife",
        "Segovia",
        "Torrelavega",
        "Elda",
        "Mérida",
        "Ávila",
        "Valdemoro",
        "Cuenta",
        "Collado Villalba",
        "Benalmádena",
        "Mollet del Vallés",
        "Puertollano",
        "Madrid",
        "Barcelona",
        "Valencia",
        "Sevilla",
        "Zaragoza",
        "Málaga",
        "Murcia",
        "Palma de Mallorca",
        "Las Palmas de Gran Canaria",
        "Bilbao",
        "Córdoba",
        "Alicante",
        "Valladolid",
        "Vigo",
        "Gijón",
        "Hospitalet de LLobregat",
        "La Coruña",
        "Granada",
        "Vitoria",
        "Elche",
        "Santa Cruz de Tenerife",
        "Oviedo",
        "Badalona",
        "Cartagena",
        "Móstoles",
        "Jerez de la Frontera",
        "Tarrasa",
        "Sabadell",
        "Alcalá de Henares",
        "Pamplona",
        "Fuenlabrada",
        "Almería",
        "San Sebastián",
        "Leganés",
        "Santander",
        "Burgos",
        "Castellón de la Plana",
        "Alcorcón",
        "Albacete",
        "Getafe",
        "Salamanca",
        "Huelva",
        "Logroño",
        "Badajoz",
        "San Cristróbal de la Laguna",
        "León",
        "Tarragona",
        "Cádiz",
        "Lérida",
        "Marbella",
        "Mataró",
        "Dos Hermanas",
        "Santa Coloma de Gramanet",
        "Jaén",
        "Algeciras",
        "Torrejón de Ardoz",
        "Orense",
        "Alcobendas",
        "Reus",
        "Calahorra",
        "Inca"
      ],
      "country": [
        "Afganistán",
        "Albania",
        "Argelia",
        "Andorra",
        "Angola",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbayán",
        "Bahamas",
        "Barein",
        "Bangladesh",
        "Barbados",
        "Bielorusia",
        "Bélgica",
        "Belice",
        "Bermuda",
        "Bután",
        "Bolivia",
        "Bosnia Herzegovina",
        "Botswana",
        "Brasil",
        "Bulgaria",
        "Burkina Faso",
        "Burundi",
        "Camboya",
        "Camerún",
        "Canada",
        "Cabo Verde",
        "Islas Caimán",
        "Chad",
        "Chile",
        "China",
        "Isla de Navidad",
        "Colombia",
        "Comodos",
        "Congo",
        "Costa Rica",
        "Costa de Marfil",
        "Croacia",
        "Cuba",
        "Chipre",
        "República Checa",
        "Dinamarca",
        "Dominica",
        "República Dominicana",
        "Ecuador",
        "Egipto",
        "El Salvador",
        "Guinea Ecuatorial",
        "Eritrea",
        "Estonia",
        "Etiopía",
        "Islas Faro",
        "Fiji",
        "Finlandia",
        "Francia",
        "Gabón",
        "Gambia",
        "Georgia",
        "Alemania",
        "Ghana",
        "Grecia",
        "Groenlandia",
        "Granada",
        "Guadalupe",
        "Guam",
        "Guatemala",
        "Guinea",
        "Guinea-Bisau",
        "Guayana",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungria",
        "Islandia",
        "India",
        "Indonesia",
        "Iran",
        "Irak",
        "Irlanda",
        "Italia",
        "Jamaica",
        "Japón",
        "Jordania",
        "Kazajistan",
        "Kenia",
        "Kiribati",
        "Corea",
        "Kuwait",
        "Letonia",
        "Líbano",
        "Liberia",
        "Liechtenstein",
        "Lituania",
        "Luxemburgo",
        "Macao",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malasia",
        "Maldivas",
        "Mali",
        "Malta",
        "Martinica",
        "Mauritania",
        "Méjico",
        "Micronesia",
        "Moldavia",
        "Mónaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Marruecos",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Holanda",
        "Nueva Zelanda",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Noruega",
        "Omán",
        "Pakistan",
        "Panamá",
        "Papúa Nueva Guinea",
        "Paraguay",
        "Perú",
        "Filipinas",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Rusia",
        "Ruanda",
        "Samoa",
        "San Marino",
        "Santo Tomé y Principe",
        "Arabia Saudí",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leona",
        "Singapur",
        "Eslovaquia",
        "Eslovenia",
        "Somalia",
        "España",
        "Sri Lanka",
        "Sudán",
        "Suriname",
        "Suecia",
        "Suiza",
        "Siria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Tailandia",
        "Timor-Leste",
        "Togo",
        "Tonga",
        "Trinidad y Tobago",
        "Tunez",
        "Turquia",
        "Uganda",
        "Ucrania",
        "Emiratos Árabes Unidos",
        "Reino Unido",
        "Estados Unidos de América",
        "Uruguay",
        "Uzbekistan",
        "Vanuatu",
        "Venezuela",
        "Vietnam",
        "Yemen",
        "Zambia",
        "Zimbabwe"
      ],
      "country_code": [
        "ES"
      ],
      "default_country": [
        "España"
      ],
      "postcode": [
        "#####"
      ],
      "province": [
        "Álava",
        "Albacete",
        "Alicante",
        "Almería",
        "Asturias",
        "Ávila",
        "Badajoz",
        "Barcelona",
        "Burgos",
        "Cantabria",
        "Castellón",
        "Ciudad Real",
        "Cuenca",
        "Cáceres",
        "Cádiz",
        "Córdoba",
        "Gerona",
        "Granada",
        "Guadalajara",
        "Guipúzcoa",
        "Huelva",
        "Huesca",
        "Islas Baleares",
        "Jaén",
        "La Coruña",
        "La Rioja",
        "Las Palmas",
        "León",
        "Lugo",
        "lérida",
        "Madrid",
        "Murcia",
        "Málaga",
        "Navarra",
        "Orense",
        "Palencia",
        "Pontevedra",
        "Salamanca",
        "Santa Cruz de Tenerife",
        "Segovia",
        "Sevilla",
        "Soria",
        "Tarragona",
        "Teruel",
        "Toledo",
        "Valencia",
        "Valladolid",
        "Vizcaya",
        "Zamora",
        "Zaragoza"
      ],
      "secondary_address": [
        "Esc. ###",
        "Puerta ###"
      ],
      "state": [
        "Andalucía",
        "Aragón",
        "Principado de Asturias",
        "Baleares",
        "Canarias",
        "Cantabria",
        "Castilla-La Mancha",
        "Castilla y León",
        "Cataluña",
        "Comunidad Valenciana",
        "Extremadura",
        "Galicia",
        "La Rioja",
        "Comunidad de Madrid",
        "Navarra",
        "País Vasco",
        "Región de Murcia"
      ],
      "state_abbr": [
        "And",
        "Ara",
        "Ast",
        "Bal",
        "Can",
        "Cbr",
        "Man",
        "Leo",
        "Cat",
        "Com",
        "Ext",
        "Gal",
        "Rio",
        "Mad",
        "Nav",
        "Vas",
        "Mur"
      ],
      "street_address": [
        "#{street_name}#{building_number}",
        "#{street_name}#{building_number} #{secondary_address}"
      ],
      "street_name": [
        "#{street_suffix} #{Name.first_name}",
        "#{street_suffix} #{Name.first_name} #{Name.last_name}"
      ],
      "street_suffix": [
        "Aldea",
        "Apartamento",
        "Arrabal",
        "Arroyo",
        "Avenida",
        "Bajada",
        "Barranco",
        "Barrio",
        "Bloque",
        "Calle",
        "Calleja",
        "Camino",
        "Carretera",
        "Caserio",
        "Colegio",
        "Colonia",
        "Conjunto",
        "Cuesta",
        "Chalet",
        "Edificio",
        "Entrada",
        "Escalinata",
        "Explanada",
        "Extramuros",
        "Extrarradio",
        "Ferrocarril",
        "Glorieta",
        "Gran Subida",
        "Grupo",
        "Huerta",
        "Jardines",
        "Lado",
        "Lugar",
        "Manzana",
        "Masía",
        "Mercado",
        "Monte",
        "Muelle",
        "Municipio",
        "Parcela",
        "Parque",
        "Partida",
        "Pasaje",
        "Paseo",
        "Plaza",
        "Poblado",
        "Polígono",
        "Prolongación",
        "Puente",
        "Puerta",
        "Quinta",
        "Ramal",
        "Rambla",
        "Rampa",
        "Riera",
        "Rincón",
        "Ronda",
        "Rua",
        "Salida",
        "Sector",
        "Sección",
        "Senda",
        "Solar",
        "Subida",
        "Terrenos",
        "Torrente",
        "Travesía",
        "Urbanización",
        "Vía",
        "Vía Pública"
      ],
      "time_zone": [
        "Pacífico/Midway",
        "Pacífico/Pago_Pago",
        "Pacífico/Honolulu",
        "America/Juneau",
        "America/Los_Angeles",
        "America/Tijuana",
        "America/Denver",
        "America/Phoenix",
        "America/Chihuahua",
        "America/Mazatlan",
        "America/Chicago",
        "America/Regina",
        "America/Mexico_City",
        "America/Mexico_City",
        "America/Monterrey",
        "America/Guatemala",
        "America/New_York",
        "America/Indiana/Indianapolis",
        "America/Bogota",
        "America/Lima",
        "America/Lima",
        "America/Halifax",
        "America/Caracas",
        "America/La_Paz",
        "America/Santiago",
        "America/St_Johns",
        "America/Sao_Paulo",
        "America/Argentina/Buenos_Aires",
        "America/Guyana",
        "America/Godthab",
        "Atlantic/South_Georgia",
        "Atlantic/Azores",
        "Atlantic/Cape_Verde",
        "Europa/Dublin",
        "Europa/London",
        "Europa/Lisbon",
        "Europa/London",
        "Africa/Casablanca",
        "Africa/Monrovia",
        "Etc/UTC",
        "Europa/Belgrade",
        "Europa/Bratislava",
        "Europa/Budapest",
        "Europa/Ljubljana",
        "Europa/Prague",
        "Europa/Sarajevo",
        "Europa/Skopje",
        "Europa/Warsaw",
        "Europa/Zagreb",
        "Europa/Brussels",
        "Europa/Copenhagen",
        "Europa/Madrid",
        "Europa/Paris",
        "Europa/Amsterdam",
        "Europa/Berlin",
        "Europa/Berlin",
        "Europa/Rome",
        "Europa/Stockholm",
        "Europa/Vienna",
        "Africa/Algiers",
        "Europa/Bucharest",
        "Africa/Cairo",
        "Europa/Helsinki",
        "Europa/Kiev",
        "Europa/Riga",
        "Europa/Sofia",
        "Europa/Tallinn",
        "Europa/Vilnius",
        "Europa/Athens",
        "Europa/Istanbul",
        "Europa/Minsk",
        "Asia/Jerusalen",
        "Africa/Harare",
        "Africa/Johannesburg",
        "Europa/Moscú",
        "Europa/Moscú",
        "Europa/Moscú",
        "Asia/Kuwait",
        "Asia/Riyadh",
        "Africa/Nairobi",
        "Asia/Baghdad",
        "Asia/Tehran",
        "Asia/Muscat",
        "Asia/Muscat",
        "Asia/Baku",
        "Asia/Tbilisi",
        "Asia/Yerevan",
        "Asia/Kabul",
        "Asia/Yekaterinburg",
        "Asia/Karachi",
        "Asia/Karachi",
        "Asia/Tashkent",
        "Asia/Kolkata",
        "Asia/Kolkata",
        "Asia/Kolkata",
        "Asia/Kolkata",
        "Asia/Kathmandu",
        "Asia/Dhaka",
        "Asia/Dhaka",
        "Asia/Colombo",
        "Asia/Almaty",
        "Asia/Novosibirsk",
        "Asia/Rangoon",
        "Asia/Bangkok",
        "Asia/Bangkok",
        "Asia/Jakarta",
        "Asia/Krasnoyarsk",
        "Asia/Shanghai",
        "Asia/Chongqing",
        "Asia/Hong_Kong",
        "Asia/Urumqi",
        "Asia/Kuala_Lumpur",
        "Asia/Singapore",
        "Asia/Taipei",
        "Australia/Perth",
        "Asia/Irkutsk",
        "Asia/Ulaanbaatar",
        "Asia/Seoul",
        "Asia/Tokyo",
        "Asia/Tokyo",
        "Asia/Tokyo",
        "Asia/Yakutsk",
        "Australia/Darwin",
        "Australia/Adelaide",
        "Australia/Melbourne",
        "Australia/Melbourne",
        "Australia/Sydney",
        "Australia/Brisbane",
        "Australia/Hobart",
        "Asia/Vladivostok",
        "Pacífico/Guam",
        "Pacífico/Port_Moresby",
        "Asia/Magadan",
        "Asia/Magadan",
        "Pacífico/Noumea",
        "Pacífico/Fiji",
        "Asia/Kamchatka",
        "Pacífico/Majuro",
        "Pacífico/Auckland",
        "Pacífico/Auckland",
        "Pacífico/Tongatapu",
        "Pacífico/Fakaofo",
        "Pacífico/Apia"
      ]
    },
    "cell_phone": {
      "formats": [
        "6##-###-###",
        "6##.###.###",
        "6## ### ###",
        "6########"
      ]
    },
    "company": {
      "buzzwords": [
        [
          "habilidad",
          "acceso",
          "adaptador",
          "algoritmo",
          "alianza",
          "analista",
          "aplicación",
          "enfoque",
          "arquitectura",
          "archivo",
          "inteligencia artificial",
          "array",
          "actitud",
          "medición",
          "gestión presupuestaria",
          "capacidad",
          "desafío",
          "circuito",
          "colaboración",
          "complejidad",
          "concepto",
          "conglomeración",
          "contingencia",
          "núcleo",
          "fidelidad",
          "base de datos",
          "data-warehouse",
          "definición",
          "emulación",
          "codificar",
          "encriptar",
          "extranet",
          "firmware",
          "flexibilidad",
          "focus group",
          "previsión",
          "base de trabajo",
          "función",
          "funcionalidad",
          "Interfaz Gráfica",
          "groupware",
          "Interfaz gráfico de usuario",
          "hardware",
          "Soporte",
          "jerarquía",
          "conjunto",
          "implementación",
          "infraestructura",
          "iniciativa",
          "instalación",
          "conjunto de instrucciones",
          "interfaz",
          "intranet",
          "base del conocimiento",
          "red de area local",
          "aprovechar",
          "matrices",
          "metodologías",
          "middleware",
          "migración",
          "modelo",
          "moderador",
          "monitorizar",
          "arquitectura abierta",
          "sistema abierto",
          "orquestar",
          "paradigma",
          "paralelismo",
          "política",
          "portal",
          "estructura de precios",
          "proceso de mejora",
          "producto",
          "productividad",
          "proyecto",
          "proyección",
          "protocolo",
          "línea segura",
          "software",
          "solución",
          "estandardización",
          "estrategia",
          "estructura",
          "éxito",
          "superestructura",
          "soporte",
          "sinergia",
          "mediante",
          "marco de tiempo",
          "caja de herramientas",
          "utilización",
          "website",
          "fuerza de trabajo"
        ],
        [
          "24 horas",
          "24/7",
          "3rd generación",
          "4th generación",
          "5th generación",
          "6th generación",
          "analizada",
          "asimétrica",
          "asíncrona",
          "monitorizada por red",
          "bidireccional",
          "bifurcada",
          "generada por el cliente",
          "cliente servidor",
          "coherente",
          "cohesiva",
          "compuesto",
          "sensible al contexto",
          "basado en el contexto",
          "basado en contenido",
          "dedicada",
          "generado por la demanda",
          "didactica",
          "direccional",
          "discreta",
          "dinámica",
          "potenciada",
          "acompasada",
          "ejecutiva",
          "explícita",
          "tolerante a fallos",
          "innovadora",
          "amplio ábanico",
          "global",
          "heurística",
          "alto nivel",
          "holística",
          "homogénea",
          "hibrida",
          "incremental",
          "intangible",
          "interactiva",
          "intermedia",
          "local",
          "logística",
          "maximizada",
          "metódica",
          "misión crítica",
          "móbil",
          "modular",
          "motivadora",
          "multimedia",
          "multiestado",
          "multitarea",
          "nacional",
          "basado en necesidades",
          "neutral",
          "nueva generación",
          "no-volátil",
          "orientado a objetos",
          "óptima",
          "optimizada",
          "radical",
          "tiempo real",
          "recíproca",
          "regional",
          "escalable",
          "secundaria",
          "orientada a soluciones",
          "estable",
          "estatica",
          "sistemática",
          "sistémica",
          "tangible",
          "terciaria",
          "transicional",
          "uniforme",
          "valor añadido",
          "vía web",
          "defectos cero",
          "tolerancia cero"
        ],
        [
          "Adaptativo",
          "Avanzado",
          "Asimilado",
          "Automatizado",
          "Equilibrado",
          "Centrado en el negocio",
          "Centralizado",
          "Clonado",
          "Compatible",
          "Configurable",
          "Multi grupo",
          "Multi plataforma",
          "Centrado en el usuario",
          "Configurable",
          "Descentralizado",
          "Digitalizado",
          "Distribuido",
          "Diverso",
          "Reducido",
          "Mejorado",
          "Para toda la empresa",
          "Ergonomico",
          "Exclusivo",
          "Expandido",
          "Extendido",
          "Cara a cara",
          "Enfocado",
          "Totalmente configurable",
          "Fundamental",
          "Orígenes",
          "Horizontal",
          "Implementado",
          "Innovador",
          "Integrado",
          "Intuitivo",
          "Inverso",
          "Gestionado",
          "Obligatorio",
          "Monitorizado",
          "Multi canal",
          "Multi lateral",
          "Multi capa",
          "En red",
          "Orientado a objetos",
          "Open-source",
          "Operativo",
          "Optimizado",
          "Opcional",
          "Organico",
          "Organizado",
          "Perseverando",
          "Persistente",
          "en fases",
          "Polarizado",
          "Pre-emptivo",
          "Proactivo",
          "Enfocado a benficios",
          "Profundo",
          "Programable",
          "Progresivo",
          "Public-key",
          "Enfocado en la calidad",
          "Reactivo",
          "Realineado",
          "Re-contextualizado",
          "Re-implementado",
          "Reducido",
          "Ingenieria inversa",
          "Robusto",
          "Fácil",
          "Seguro",
          "Auto proporciona",
          "Compartible",
          "Intercambiable",
          "Sincronizado",
          "Orientado a equipos",
          "Total",
          "Universal",
          "Mejorado",
          "Actualizable",
          "Centrado en el usuario",
          "Amigable",
          "Versatil",
          "Virtual",
          "Visionario"
        ]
      ],
      "industry": [
        "Defensa",
        "Equipo de Cómputo",
        "Software",
        "Redes",
        "Internet",
        "Semiconductores",
        "Telecomunicaciones",
        "Despacho de Abogados",
        "Servicos Legales",
        "Consultoría en Administración",
        "Biotecnología",
        "Clínica",
        "Hospitales y Cuidado Médico",
        "Farmacéutica",
        "Veterinaria",
        "Dispositivos Médicos",
        "Cosméticos",
        "Moda",
        "Equipo Deportivo",
        "Tabaco",
        "Supermercados",
        "Elaboración de Comida",
        "Electrodomésticos",
        "Bienes",
        "Muebles",
        "Retail",
        "Entretenimiento",
        "Juegos y Apuestas",
        "Viajes y Turismo",
        "Hospitalidad",
        "Restaurantes",
        "Deportes",
        "Comida y Bebida",
        "Cine",
        "Broadcast Media",
        "Museos e Instituciones",
        "Bellas Artes",
        "Artes Escénicas",
        "Banca",
        "Seguros",
        "Servicios Financieros",
        "Bienes Raíces",
        "Banca de Inversión",
        "Manejo de Inversiones",
        "Contabilidad",
        "Construcción",
        "Materiales de Construcción",
        "Arquitectura",
        "Ingeniería Civil",
        "Aeroespacial",
        "Automotriz",
        "Química",
        "Maquinaria",
        "Minería y Metales",
        "Petróleo y Energía",
        "Construcción de Barcos",
        "Servicios",
        "Textiles",
        "Papel",
        "Ferrocarriles",
        "Agricultura",
        "Ganadería",
        "Lácteos",
        "Pesca",
        "Educación Basica",
        "Educación Media Superior",
        "Administración de Educación",
        "Investigación",
        "Militar",
        "Asamblea Legislativa",
        "Juzgado",
        "Relaciones Internacionales",
        "Gobierno",
        "Dirección General",
        "Policía",
        "Seguridad Pública",
        "Política Pública",
        "Marketing",
        "Periódicos",
        "Publicaciones",
        "Imprenta",
        "Tecnologías de Información",
        "Bibliotecas",
        "Medio Ambiente",
        "Paquetería y Mensajería",
        "Servicios Familiares",
        "Instituciones Religiosas",
        "Sociedad Civil",
        "Servicios del Consumidor",
        "Transportes",
        "Almacenamiento",
        "Líneas Aéreas",
        "Marítimo",
        "Investigación de Mercado",
        "Relaciones Públicas",
        "Diseño",
        "Sin Fines de Lucro",
        "Recaudación",
        "Edición",
        "Staffing y Reclutamiento",
        "Coaching",
        "VC",
        "Partidos Políticos",
        "Traducciones",
        "Juegos de Cómputo",
        "Planeación de Eventos",
        "Artes y Manualidades",
        "Manufactura Eléctrica/Electrónica",
        "Medios Online",
        "Nanotecnología",
        "Música",
        "Logística y Supply Chain",
        "Plásticos",
        "Seguridad de Cómputo y Redes",
        "Inalámbrico",
        "Outsourcing / Offshoring",
        "Bienestar y Salud",
        "Medicina Alternativa",
        "Producción de Medios",
        "Animación",
        "Bienes Raíces Comerciales",
        "Mercados Capitales",
        "Filantropía",
        "E-Learning",
        "Mayoreo",
        "Importaciones y Exportaciones",
        "Ingeniería Mecánica e Industrial",
        "Fotografía",
        "Recursos Humanos",
        "Equipo de Oficina",
        "Cuidado de la Salud Mental",
        "Diseño Gráfico",
        "Desarrollo y Comercio Exterior",
        "Vinos y Licores",
        "Joyería y Bienes de Lujo",
        "Renovables y Medio Ambiente",
        "Vidrios y Cerámicos",
        "Almacenamiento y Contenedores",
        "Automatización Industrial",
        "Relaciones Gubernamentales"
      ],
      "name": [
        "#{Name.last_name} #{suffix}",
        "#{Name.last_name} y #{Name.last_name}",
        "#{Name.last_name} #{Name.last_name} #{suffix}",
        "#{Name.last_name}, #{Name.last_name} y #{Name.last_name} Asociados"
      ],
      "profession": [
        "maestro",
        "actor",
        "músico",
        "filósofo",
        "escritor",
        "doctor",
        "contador",
        "agricultor",
        "arquitecto",
        "economista",
        "ingeniero",
        "intérprete",
        "abogado",
        "bibliotecario",
        "actuario",
        "recursos humanos",
        "bombero",
        "juez",
        "policía",
        "astrónomo",
        "biólogo",
        "químico",
        "físico",
        "programador",
        "desarrollador web",
        "diseñador"
      ],
      "suffix": [
        "S.L.",
        "e Hijos",
        "S.A.",
        "Hermanos"
      ],
      "university": {
        "name": [
          "#{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{Name.last_name} #{University.suffix}",
          "#{University.prefix} #{Name.last_name}",
          "#{University.prefix} #{Address.state} #{University.suffix}"
        ],
        "prefix": [
          "El",
          "Septentrional",
          "Norte",
          "Occidental",
          "Oeste",
          "Del Sur",
          "Sur",
          "Oriental",
          "Oriente"
        ],
        "suffix": [
          "Universidad",
          "Instituto",
          "Academia"
        ]
      }
    },
    "internet": {
      "domain_suffix": [
        "com",
        "es",
        "info",
        "com.es",
        "org"
      ],
      "free_email": [
        "gmail.com",
        "yahoo.com",
        "hotmail.com"
      ]
    },
    "music": {
      "instruments": [
        "Guitarra Eléctrica",
        "Guitarra Acústica",
        "Flauta",
        "Trompeta",
        "Clarinete",
        "Violonchelo",
        "Arpa",
        "Xilofón",
        "Armónica",
        "Acordión",
        "Organo",
        "Piano",
        "Ukelele",
        "Saxofón",
        "Bateria",
        "Violín",
        "Bajo"
      ]
    },
    "name": {
      "female_first_name": [
        "Adela",
        "Adriana",
        "Alejandra",
        "Alicia",
        "Amalia",
        "Ana",
        "Ana Luisa",
        "Ana María",
        "Andrea",
        "Anita",
        "Ángela",
        "Antonia",
        "Ariadna",
        "Barbara",
        "Beatriz",
        "Berta",
        "Blanca",
        "Caridad",
        "Carla",
        "Carlota",
        "Carmen",
        "Carolina",
        "Catalina",
        "Cecilia",
        "Clara",
        "Claudia",
        "Concepción",
        "Conchita",
        "Cristina",
        "Daniela",
        "Débora",
        "Diana",
        "Dolores",
        "Lola",
        "Dorotea",
        "Elena",
        "Elisa",
        "Eloisa",
        "Elsa",
        "Elvira",
        "Emilia",
        "Esperanza",
        "Estela",
        "Ester",
        "Eva",
        "Florencia",
        "Francisca",
        "Gabriela",
        "Gloria",
        "Graciela",
        "Guadalupe",
        "Guillermina",
        "Inés",
        "Irene",
        "Isabel",
        "Isabela",
        "Josefina",
        "Juana",
        "Julia",
        "Laura",
        "Leonor",
        "Leticia",
        "Lilia",
        "Lorena",
        "Lourdes",
        "Lucia",
        "Luisa",
        "Luz",
        "Magdalena",
        "Manuela",
        "Marcela",
        "Margarita",
        "María",
        "María del Carmen",
        "María Cristina",
        "María Elena",
        "María Eugenia",
        "María José",
        "María Luisa",
        "María Soledad",
        "María Teresa",
        "Mariana",
        "Maricarmen",
        "Marilu",
        "Marisol",
        "Marta",
        "Mayte",
        "Mercedes",
        "Micaela",
        "Mónica",
        "Natalia",
        "Norma",
        "Olivia",
        "Patricia",
        "Pilar",
        "Ramona",
        "Raquel",
        "Rebeca",
        "Reina",
        "Rocio",
        "Rosa",
        "Rosalia",
        "Rosario",
        "Sara",
        "Silvia",
        "Sofia",
        "Soledad",
        "Sonia",
        "Susana",
        "Teresa",
        "Verónica",
        "Victoria",
        "Virginia",
        "Yolanda"
      ],
      "first_name": [
        "#{female_first_name}",
        "#{male_first_name}"
      ],
      "last_name": [
        "Abeyta",
        "Abrego",
        "Abreu",
        "Acevedo",
        "Acosta",
        "Acuña",
        "Adame",
        "Adorno",
        "Agosto",
        "Aguayo",
        "Águilar",
        "Aguilera",
        "Aguirre",
        "Alanis",
        "Alaniz",
        "Alarcón",
        "Alba",
        "Alcala",
        "Alcántar",
        "Alcaraz",
        "Alejandro",
        "Alemán",
        "Alfaro",
        "Alicea",
        "Almanza",
        "Almaraz",
        "Almonte",
        "Alonso",
        "Alonzo",
        "Altamirano",
        "Alva",
        "Alvarado",
        "Alvarez",
        "Amador",
        "Amaya",
        "Anaya",
        "Anguiano",
        "Angulo",
        "Aparicio",
        "Apodaca",
        "Aponte",
        "Aragón",
        "Araña",
        "Aranda",
        "Arce",
        "Archuleta",
        "Arellano",
        "Arenas",
        "Arevalo",
        "Arguello",
        "Arias",
        "Armas",
        "Armendáriz",
        "Armenta",
        "Armijo",
        "Arredondo",
        "Arreola",
        "Arriaga",
        "Arroyo",
        "Arteaga",
        "Atencio",
        "Ávalos",
        "Ávila",
        "Avilés",
        "Ayala",
        "Baca",
        "Badillo",
        "Báez",
        "Baeza",
        "Bahena",
        "Balderas",
        "Ballesteros",
        "Banda",
        "Bañuelos",
        "Barajas",
        "Barela",
        "Barragán",
        "Barraza",
        "Barrera",
        "Barreto",
        "Barrientos",
        "Barrios",
        "Batista",
        "Becerra",
        "Beltrán",
        "Benavides",
        "Benavídez",
        "Benítez",
        "Bermúdez",
        "Bernal",
        "Berríos",
        "Bétancourt",
        "Blanco",
        "Bonilla",
        "Borrego",
        "Botello",
        "Bravo",
        "Briones",
        "Briseño",
        "Brito",
        "Bueno",
        "Burgos",
        "Bustamante",
        "Bustos",
        "Caballero",
        "Cabán",
        "Cabrera",
        "Cadena",
        "Caldera",
        "Calderón",
        "Calvillo",
        "Camacho",
        "Camarillo",
        "Campos",
        "Canales",
        "Candelaria",
        "Cano",
        "Cantú",
        "Caraballo",
        "Carbajal",
        "Cardenas",
        "Cardona",
        "Carmona",
        "Carranza",
        "Carrasco",
        "Carrasquillo",
        "Carreón",
        "Carrera",
        "Carrero",
        "Carrillo",
        "Carrion",
        "Carvajal",
        "Casanova",
        "Casares",
        "Casárez",
        "Casas",
        "Casillas",
        "Castañeda",
        "Castellanos",
        "Castillo",
        "Castro",
        "Cavazos",
        "Cazares",
        "Ceballos",
        "Cedillo",
        "Ceja",
        "Centeno",
        "Cepeda",
        "Cerda",
        "Cervantes",
        "Cervántez",
        "Chacón",
        "Chapa",
        "Chavarría",
        "Chávez",
        "Cintrón",
        "Cisneros",
        "Collado",
        "Collazo",
        "Colón",
        "Colunga",
        "Concepción",
        "Contreras",
        "Cordero",
        "Córdova",
        "Cornejo",
        "Corona",
        "Coronado",
        "Corral",
        "Corrales",
        "Correa",
        "Cortés",
        "Cortez",
        "Cotto",
        "Covarrubias",
        "Crespo",
        "Cruz",
        "Cuellar",
        "Curiel",
        "Dávila",
        "de Anda",
        "de Jesús",
        "Delacrúz",
        "Delafuente",
        "Delagarza",
        "Delao",
        "Delapaz",
        "Delarosa",
        "Delatorre",
        "Deleón",
        "Delgadillo",
        "Delgado",
        "Delrío",
        "Delvalle",
        "Díaz",
        "Domínguez",
        "Domínquez",
        "Duarte",
        "Dueñas",
        "Duran",
        "Echevarría",
        "Elizondo",
        "Enríquez",
        "Escalante",
        "Escamilla",
        "Escobar",
        "Escobedo",
        "Esparza",
        "Espinal",
        "Espino",
        "Espinosa",
        "Espinoza",
        "Esquibel",
        "Esquivel",
        "Estévez",
        "Estrada",
        "Fajardo",
        "Farías",
        "Feliciano",
        "Fernández",
        "Ferrer",
        "Fierro",
        "Figueroa",
        "Flores",
        "Flórez",
        "Fonseca",
        "Franco",
        "Frías",
        "Fuentes",
        "Gaitán",
        "Galarza",
        "Galindo",
        "Gallardo",
        "Gallegos",
        "Galván",
        "Gálvez",
        "Gamboa",
        "Gamez",
        "Gaona",
        "Garay",
        "García",
        "Garibay",
        "Garica",
        "Garrido",
        "Garza",
        "Gastélum",
        "Gaytán",
        "Gil",
        "Girón",
        "Godínez",
        "Godoy",
        "Gómez",
        "Gonzales",
        "González",
        "Gollum",
        "Gracia",
        "Granado",
        "Granados",
        "Griego",
        "Grijalva",
        "Guajardo",
        "Guardado",
        "Guerra",
        "Guerrero",
        "Guevara",
        "Guillen",
        "Gurule",
        "Gutiérrez",
        "Guzmán",
        "Haro",
        "Henríquez",
        "Heredia",
        "Hernádez",
        "Hernandes",
        "Hernández",
        "Herrera",
        "Hidalgo",
        "Hinojosa",
        "Holguín",
        "Huerta",
        "Hurtado",
        "Ibarra",
        "Iglesias",
        "Irizarry",
        "Jaime",
        "Jaimes",
        "Jáquez",
        "Jaramillo",
        "Jasso",
        "Jiménez",
        "Jimínez",
        "Juárez",
        "Jurado",
        "Laboy",
        "Lara",
        "Laureano",
        "Leal",
        "Lebrón",
        "Ledesma",
        "Leiva",
        "Lemus",
        "León",
        "Lerma",
        "Leyva",
        "Limón",
        "Linares",
        "Lira",
        "Llamas",
        "Loera",
        "Lomeli",
        "Longoria",
        "López",
        "Lovato",
        "Loya",
        "Lozada",
        "Lozano",
        "Lucero",
        "Lucio",
        "Luevano",
        "Lugo",
        "Luna",
        "Macías",
        "Madera",
        "Madrid",
        "Madrigal",
        "Maestas",
        "Magaña",
        "Malave",
        "Maldonado",
        "Manzanares",
        "Mares",
        "Marín",
        "Márquez",
        "Marrero",
        "Marroquín",
        "Martínez",
        "Mascareñas",
        "Mata",
        "Mateo",
        "Matías",
        "Matos",
        "Maya",
        "Mayorga",
        "Medina",
        "Medrano",
        "Mejía",
        "Meléndez",
        "Melgar",
        "Mena",
        "Menchaca",
        "Méndez",
        "Mendoza",
        "Menéndez",
        "Meraz",
        "Mercado",
        "Merino",
        "Mesa",
        "Meza",
        "Miramontes",
        "Miranda",
        "Mireles",
        "Mojica",
        "Molina",
        "Mondragón",
        "Monroy",
        "Montalvo",
        "Montañez",
        "Montaño",
        "Montemayor",
        "Montenegro",
        "Montero",
        "Montes",
        "Montez",
        "Montoya",
        "Mora",
        "Morales",
        "Moreno",
        "Mota",
        "Moya",
        "Munguía",
        "Muñiz",
        "Muñoz",
        "Murillo",
        "Muro",
        "Nájera",
        "Naranjo",
        "Narváez",
        "Nava",
        "Navarrete",
        "Navarro",
        "Nazario",
        "Negrete",
        "Negrón",
        "Nevárez",
        "Nieto",
        "Nieves",
        "Niño",
        "Noriega",
        "Núñez",
        "Ocampo",
        "Ocasio",
        "Ochoa",
        "Ojeda",
        "Olivares",
        "Olivárez",
        "Olivas",
        "Olivera",
        "Olivo",
        "Olmos",
        "Olvera",
        "Ontiveros",
        "Oquendo",
        "Ordóñez",
        "Orellana",
        "Ornelas",
        "Orosco",
        "Orozco",
        "Orta",
        "Ortega",
        "Ortiz",
        "Osorio",
        "Otero",
        "Ozuna",
        "Pabón",
        "Pacheco",
        "Padilla",
        "Padrón",
        "Páez",
        "Pagan",
        "Palacios",
        "Palomino",
        "Palomo",
        "Pantoja",
        "Paredes",
        "Parra",
        "Partida",
        "Patiño",
        "Paz",
        "Pedraza",
        "Pedroza",
        "Pelayo",
        "Peña",
        "Perales",
        "Peralta",
        "Perea",
        "Peres",
        "Pérez",
        "Pichardo",
        "Piña",
        "Pineda",
        "Pizarro",
        "Polanco",
        "Ponce",
        "Porras",
        "Portillo",
        "Posada",
        "Prado",
        "Preciado",
        "Prieto",
        "Puente",
        "Puga",
        "Pulido",
        "Quesada",
        "Quezada",
        "Quiñones",
        "Quiñónez",
        "Quintana",
        "Quintanilla",
        "Quintero",
        "Quiroz",
        "Rael",
        "Ramírez",
        "Ramón",
        "Ramos",
        "Rangel",
        "Rascón",
        "Raya",
        "Razo",
        "Regalado",
        "Rendón",
        "Rentería",
        "Reséndez",
        "Reyes",
        "Reyna",
        "Reynoso",
        "Rico",
        "Rincón",
        "Riojas",
        "Ríos",
        "Rivas",
        "Rivera",
        "Rivero",
        "Robledo",
        "Robles",
        "Rocha",
        "Rodarte",
        "Rodrígez",
        "Rodríguez",
        "Rodríquez",
        "Rojas",
        "Rojo",
        "Roldán",
        "Rolón",
        "Romero",
        "Romo",
        "Roque",
        "Rosado",
        "Rosales",
        "Rosario",
        "Rosas",
        "Roybal",
        "Rubio",
        "Ruelas",
        "Ruiz",
        "Saavedra",
        "Sáenz",
        "Saiz",
        "Salas",
        "Salazar",
        "Salcedo",
        "Salcido",
        "Saldaña",
        "Saldivar",
        "Salgado",
        "Salinas",
        "Samaniego",
        "Sanabria",
        "Sanches",
        "Sánchez",
        "Sandoval",
        "Santacruz",
        "Santana",
        "Santiago",
        "Santillán",
        "Sarabia",
        "Sauceda",
        "Saucedo",
        "Sedillo",
        "Segovia",
        "Segura",
        "Sepúlveda",
        "Serna",
        "Serrano",
        "Serrato",
        "Sevilla",
        "Sierra",
        "Sisneros",
        "Solano",
        "Solís",
        "Soliz",
        "Solorio",
        "Solorzano",
        "Soria",
        "Sosa",
        "Sotelo",
        "Soto",
        "Suárez",
        "Tafoya",
        "Tamayo",
        "Tamez",
        "Tapia",
        "Tejada",
        "Tejeda",
        "Téllez",
        "Tello",
        "Terán",
        "Terrazas",
        "Tijerina",
        "Tirado",
        "Toledo",
        "Toro",
        "Torres",
        "Tórrez",
        "Tovar",
        "Trejo",
        "Treviño",
        "Trujillo",
        "Ulibarri",
        "Ulloa",
        "Urbina",
        "Ureña",
        "Urías",
        "Uribe",
        "Urrutia",
        "Vaca",
        "Valadez",
        "Valdés",
        "Valdez",
        "Valdivia",
        "Valencia",
        "Valentín",
        "Valenzuela",
        "Valladares",
        "Valle",
        "Vallejo",
        "Valles",
        "Valverde",
        "Vanegas",
        "Varela",
        "Vargas",
        "Vásquez",
        "Vázquez",
        "Vega",
        "Vela",
        "Velasco",
        "Velásquez",
        "Velázquez",
        "Vélez",
        "Véliz",
        "Venegas",
        "Vera",
        "Verdugo",
        "Verduzco",
        "Vergara",
        "Viera",
        "Vigil",
        "Villa",
        "Villagómez",
        "Villalobos",
        "Villalpando",
        "Villanueva",
        "Villareal",
        "Villarreal",
        "Villaseñor",
        "Villegas",
        "Yáñez",
        "Ybarra",
        "Zambrano",
        "Zamora",
        "Zamudio",
        "Zapata",
        "Zaragoza",
        "Zarate",
        "Zavala",
        "Zayas",
        "Zelaya",
        "Zepeda",
        "Zúñiga"
      ],
      "male_first_name": [
        "Adán",
        "Agustín",
        "Alberto",
        "Alejandro",
        "Alfonso",
        "Alfredo",
        "Andrés",
        "Antonio",
        "Armando",
        "Arturo",
        "Benito",
        "Benjamín",
        "Bernardo",
        "Carlos",
        "César",
        "Claudio",
        "Clemente",
        "Cristian",
        "Cristobal",
        "Daniel",
        "David",
        "Diego",
        "Eduardo",
        "Emilio",
        "Enrique",
        "Ernesto",
        "Esteban",
        "Federico",
        "Felipe",
        "Fernando",
        "Francisco",
        "Gabriel",
        "Gerardo",
        "Germán",
        "Gilberto",
        "Gonzalo",
        "Gregorio",
        "Guillermo",
        "Gustavo",
        "Hernán",
        "Homero",
        "Horacio",
        "Hugo",
        "Ignacio",
        "Jacobo",
        "Jaime",
        "Javier",
        "Jerónimo",
        "Jesús",
        "Joaquín",
        "Jorge",
        "Jorge Luis",
        "José",
        "José Eduardo",
        "José Emilio",
        "José Luis",
        "José María",
        "Juan",
        "Juan Carlos",
        "Julio",
        "Julio César",
        "Lorenzo",
        "Lucas",
        "Luis",
        "Luis Miguel",
        "Manuel",
        "Marco Antonio",
        "Marcos",
        "Mariano",
        "Mario",
        "Martín",
        "Mateo",
        "Miguel",
        "Miguel Ángel",
        "Nicolás",
        "Octavio",
        "Óscar",
        "Pablo",
        "Patricio",
        "Pedro",
        "Rafael",
        "Ramiro",
        "Ramón",
        "Raúl",
        "Ricardo",
        "Roberto",
        "Rodrigo",
        "Rubén",
        "Salvador",
        "Samuel",
        "Sancho",
        "Santiago",
        "Sergio",
        "Teodoro",
        "Timoteo",
        "Tomás",
        "Vicente",
        "Víctor"
      ],
      "name": [
        "#{prefix} #{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name}"
      ],
      "name_with_middle": [
        "#{prefix} #{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name} #{suffix}",
        "#{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name}",
        "#{first_name} #{last_name} #{last_name}"
      ],
      "prefix": [
        "Sr.",
        "Sra.",
        "Sta."
      ],
      "suffix": [
        "Jr.",
        "Sr.",
        "I",
        "II",
        "III",
        "IV",
        "V",
        "MD",
        "DDS",
        "PhD",
        "DVM"
      ],
      "title": {
        "descriptor": [
          "Jefe",
          "Senior",
          "Directo",
          "Corporativo",
          "Dinánmico",
          "Futuro",
          "Producto",
          "Nacional",
          "Regional",
          "Distrito",
          "Central",
          "Global",
          "Cliente",
          "Inversor",
          "International",
          "Heredado",
          "Adelante",
          "Interno",
          "Humano",
          "Gerente",
          "Director"
        ],
        "job": [
          "Supervisor",
          "Asociado",
          "Ejecutivo",
          "Relacciones",
          "Oficial",
          "Gerente",
          "Ingeniero",
          "Especialista",
          "Director",
          "Coordinador",
          "Administrador",
          "Arquitecto",
          "Analista",
          "Diseñador",
          "Planificador",
          "Técnico",
          "Funcionario",
          "Desarrollador",
          "Productor",
          "Consultor",
          "Asistente",
          "Facilitador",
          "Agente",
          "Representante",
          "Estratega"
        ],
        "level": [
          "Soluciones",
          "Programa",
          "Marca",
          "Seguridada",
          "Investigación",
          "Marketing",
          "Normas",
          "Implementación",
          "Integración",
          "Funcionalidad",
          "Respuesta",
          "Paradigma",
          "Tácticas",
          "Identidad",
          "Mercados",
          "Grupo",
          "División",
          "Aplicaciones",
          "Optimización",
          "Operaciones",
          "Infraestructura",
          "Intranet",
          "Comunicaciones",
          "Web",
          "Calidad",
          "Seguro",
          "Mobilidad",
          "Cuentas",
          "Datos",
          "Creativo",
          "Configuración",
          "Contabilidad",
          "Interacciones",
          "Factores",
          "Usabilidad",
          "Métricas"
        ]
      }
    },
    "phone_number": {
      "formats": [
        "9##-###-###",
        "9##.###.###",
        "9## ### ###",
        "9########"
      ]
    },
    "subscription": {
      "payment_methods": [
        "Tarjeta de credito",
        "Tarjeta de débito",
        "Paypal",
        "Efectivo",
        "Transferencia de dinero",
        "Bitcoins",
        "Cheque",
        "Apple Pay",
        "Google Pay",
        "WeChat Pay",
        "Alipay",
        "Visa Checkout"
      ],
      "payment_terms": [
        "Pago por adelantado",
        "Mensual",
        "Anual",
        "Suscripción completa"
      ],
      "plans": [
        "Prueba gratuita",
        "Basico",
        "Starter",
        "Essential",
        "Estudiante",
        "Bronze\"",
        "Standard",
        "Silver",
        "Gold",
        "Platinum",
        "Profesional",
        "Business",
        "Diamond",
        "Premium"
      ],
      "statuses": [
        "Activo",
        "Parado",
        "Bloqueado",
        "Pendiente"
      ],
      "subscription_terms": [
        "Diaria",
        "Semanal",
        "Mensual",
        "Anual",
        "Bienal",
        "Trienal",
        "Quinquenal",
        "De por vida"
      ]
    },
    "vehicle": {
      "license_plate": "####[B-DF-HJ-NPR-TV-Z]{3}",
      "license_plate_by_state": {
        "A": "A####[A-PS-Z]{1,2}",
        "AB": "AB####[A-PS-Z]{1,2}",
        "AL": "AL####[A-PS-Z]{1,2}",
        "AV": "AV####[A-PS-Z]{1,2}",
        "B": "B####[A-PS-Z]{1,2}",
        "BA": "BA####[A-PS-Z]{1,2}",
        "BI": "BI####[A-PS-Z]{1,2}",
        "BU": "BU####[A-PS-Z]{1,2}",
        "C": "C####[A-PS-Z]{1,2}",
        "CA": "CA####[A-PS-Z]{1,2}",
        "CC": "CC####[A-PS-Z]{1,2}",
        "CE": "CE####[A-PS-Z]{1,2}",
        "CO": "CO####[A-PS-Z]{1,2}",
        "CR": "CR####[A-PS-Z]{1,2}",
        "CS": "CS####[A-PS-Z]{1,2}",
        "CU": "CU####[A-PS-Z]{1,2}",
        "GC": "GC####[A-PS-Z]{1,2}",
        "GI": "GI####[A-PS-Z]{1,2}",
        "GR": "GR####[A-PS-Z]{1,2}",
        "GU": "GU####[A-PS-Z]{1,2}",
        "H": "H####[A-PS-Z]{1,2}",
        "HU": "HU####[A-PS-Z]{1,2}",
        "IB": "IB####[A-PS-Z]{1,2}",
        "J": "J####[A-PS-Z]{1,2}",
        "L": "L####[A-PS-Z]{1,2}",
        "LE": "LE####[A-PS-Z]{1,2}",
        "LO": "LO####[A-PS-Z]{1,2}",
        "LU": "LU####[A-PS-Z]{1,2}",
        "M": "M####[A-PS-Z]{1,2}",
        "MA": "MA####[A-PS-Z]{1,2}",
        "ML": "ML####[A-PS-Z]{1,2}",
        "MU": "MU####[A-PS-Z]{1,2}",
        "NA": "NA####[A-PS-Z]{1,2}",
        "O": "O####[A-PS-Z]{1,2}",
        "OU": "OU####[A-PS-Z]{1,2}",
        "P": "P####[A-PS-Z]{1,2}",
        "PO": "PO####[A-PS-Z]{1,2}",
        "S": "S####[A-PS-Z]{1,2}",
        "SA": "SA####[A-PS-Z]{1,2}",
        "SE": "SE####[A-PS-Z]{1,2}",
        "SG": "SG####[A-PS-Z]{1,2}",
        "SO": "SO####[A-PS-Z]{1,2}",
        "SS": "SS####[A-PS-Z]{1,2}",
        "T": "T####[A-PS-Z]{1,2}",
        "TE": "TE####[A-PS-Z]{1,2}",
        "TF": "TF####[A-PS-Z]{1,2}",
        "TO": "TO####[A-PS-Z]{1,2}",
        "V": "V####[A-PS-Z]{1,2}",
        "VA": "VA####[A-PS-Z]{1,2}",
        "VI": "VI####[A-PS-Z]{1,2}",
        "Z": "Z####[A-PS-Z]{1,2}",
        "ZA": "ZA####[A-PS-Z]{1,2}"
      }
    }
  },
  "global": {
    "admin": {
      "en": "Ingles",
      "es": "Español",
      "fr": "Frances",
      "ru": "Ruso"
    },
    "footer": {
      "faqs": "Preguntas frecuentes",
      "privacy_policy": "Política de Privacidad y Uso de Cookies",
      "term_and_conditions": "Términos y condiciones"
    },
    "in_maintenance": {
      "content": "En estos momentos estamos ejecutando acciones de mantenimiento. Estaremos en línea muy pronto.",
      "icon": ":(",
      "not_acceptable": "Petición no aceptada.",
      "title": "¡Lamentamos las molestias!"
    },
    "main": {
      "form": {
        "message": {
          "checking_availability": "Comprobando la disponibilidad del servicio solicitado...",
          "create_shooping_cart": "Validando datos de la renta...",
          "no_availability": "No hay disponibilidad para el servicio solicitado.",
          "search_modality": "Buscando modalidad de renta...",
          "search_tariff": "Buscando tarifa de renta..."
        },
        "select_category": "Seleccione una categoría",
        "select_destiny": "Seleccione un destino",
        "select_drivers": "Cantidad de conductores",
        "select_modality": "Seleccione una modalidad",
        "select_office": "Seleccione una oficina",
        "select_option": "Selecione una opción",
        "select_pack": "Seleccione un pack",
        "work_all_day": "Esta oficina trabaja 24 horas.",
        "work_by_hours": "Esta oficina trabaja en el horario de %{from} a %{to} "
      },
      "info": "Ver detalles",
      "read_more": "Leer más...",
      "view_more": "Ver más"
    },
    "online_asistan": "Asistencia en Línea",
    "policies": "Políticas",
    "popup": {
      "cancel_rent_cancel": "No, continuar con mi reserva",
      "cancel_rent_confirm": "Si, cancelar",
      "create_shopping_cart_confirm": "Entendido",
      "product_no_disponibility_confirm": "Entendido",
      "verify_email_confirm": "Validar",
      "verify_email_in_process_confirm": "Entendido",
      "verify_login_for_rent_cancel": "Cancelar",
      "verify_login_for_rent_cancel_confirm": "Entendido",
      "verify_login_for_rent_confirm": "Iniciar sesión",
      "verify_login_for_rent_denied": "Registrarme",
      "with_rent_cancel": "No, continuar con el antiguo",
      "with_rent_confirm": "Si, deseo continuar",
      "with_rent_in_pay_process_cancel": "No deseo continuar",
      "with_rent_in_pay_process_cancel_confirm": "Entendido",
      "with_rent_in_pay_process_confirm": "Si, deseo continuar",
      "with_rent_redirect_to_pay_confirm": "Si, deseo continuar",
      "with_rent_redirect_to_paycancel": "No, Cancelar la reserva",
      "without_rent_confirm": "Entendido"
    },
    "section_an_page": {
      "back": "Regresar",
      "back_to_home": "Regresar al inicio",
      "go_to_admin": "Ir a la administración",
      "print": "Imprimir"
    },
    "slide_to_show_more": "Puede deslizar el menú para ver más productos",
    "slogan": "Empresa de Transporte Turístico Transtur",
    "time": {
      "centuries": "Siglo (s)",
      "day": "Día (s)",
      "hours": "Hora (s)",
      "minutes": "Minuto (s)",
      "months": "Mes (es)",
      "seconds": "Segundo (s)",
      "years": "Año (s)"
    }
  },
  "helpers": {
    "select": {
      "prompt": "Por favor seleccione"
    },
    "submit": {
      "create": "Crear %{model}",
      "submit": "Guardar %{model}",
      "update": "Actualizar %{model}"
    }
  },
  "histories": {
    "check_reservation": {
      "address": "Dirección",
      "client": "Cliente",
      "create_at": "Creado",
      "days": "Días",
      "droppof_place": "Lugar de entrega",
      "email": "Correo electrónico",
      "from": "Desde",
      "name_last_name": "Nombre(s) y Apellidos",
      "notice": "Guarde su voucher y al ingresar al Shuttle o al Bus Tour muestre el QR de su reserva.",
      "pickup_place": "Lugar de recogida",
      "price": "Precio",
      "product": "Producto",
      "product_name": "Nombre",
      "quantity": "Cantidad",
      "reference_number": "No. Referencia",
      "reservation_status": "Estado de la reserva",
      "sign_invoice": "La factura se creó en una computadora y es válida sin la firma y el sello.",
      "status_cancel": "Cancelada",
      "status_confirmation": "Confirmada",
      "status_in_confirmation": "En confirmación",
      "status_modify": "Modificada",
      "thanks": "Gracias por usar nuestros servicios!!!",
      "to": "Hasta",
      "total": "Total",
      "total_price": "Precio total"
    }
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    },
    "transliterate": {
      "rule": {
        "Á": "A",
        "É": "E",
        "Í": "I",
        "Ñ": "N",
        "Ó": "O",
        "Ú": "U",
        "Ü": "U",
        "á": "a",
        "é": "e",
        "í": "i",
        "ñ": "n",
        "ó": "o",
        "ú": "u",
        "ü": "u"
      }
    }
  },
  "login_and_register": {
    "email_validate": {
      "invalid_token": "El token proporcionado no se encuentra o ha expirado, contacto con un administrador.",
      "request_validate_no_authenticated": "Debe de autenticarse para poder validar su correo",
      "request_validate_token": "Se le ha enviado un mensaje de validación al correo <strong>%{email}</strong>, por favor siga las instrucciones del mismo para validar su cuenta.<br><hr><small>Si no aparece en su bandeja de entrada, revise la carpeta de spam.</small>",
      "request_validate_token_error": "Ha ocurrido un error al enviar el correo, inténtelo más tarde, si el error persiste.<br> <strong>Contacte con un administrador</strong>",
      "title": "Validación de Email",
      "validate_error": "Ha ocurrido un error y su cuenta no se ha podido validar, inténtelo más tarde o pongase en contacto con un administrador.",
      "validate_successfully": "<p>Estimado(a) <strong>%{name}</strong></p>Su cuenta fue validada correctamente!!!",
      "validate_token": "<p>Estimado(a) %{name}.</p> Su cuenta fue validada anteriormente, no es necesario realizar la accción."
    },
    "forgot_my_password": {
      "email": "Correo electrónico",
      "helper": "Por favor introduzca su dirección de correo",
      "send_btn": "Enviar",
      "title": "Olvide mi contraseña"
    },
    "login": {
      "auth_message_error": "Usted ya se encuentra autenticado",
      "dont_have_account": "¿No tienes una cuenta aún?",
      "dont_have_account_register": "registrate aqui",
      "email": "Correo electrónico",
      "forgot_my_password": "Si olvidaste tu contraseña puedes",
      "forgot_my_password_recovery": "recuperarla aquí.",
      "login_message_error": "Usuario o Contraseña incorrecto",
      "password": "Contraseña",
      "remember_me": "Recuerdame",
      "title": "Iniciar sesión",
      "username_and_email": "Usuario ó Correo electrónico"
    },
    "password_reset": {
      "can_change_password": "Puede cambiar su contraseña",
      "change_password": "Cambiar contraseña",
      "change_password_invalid": "Solicitud invalida.",
      "change_password_time_expire": "Ha expirado el tiempo para cambiar su contraseña.",
      "email_incorrect": "Error al generar el token temporal para el reestablecimeinto de su contraseña",
      "email_send_error": "No podemos avalar que su correo se encuentre en nuestro sitio",
      "email_send_success": "Se a enviado un correo con los datos para reestabler su contraseña",
      "helper_text": "Si esta viendo este cuadro es porque usted solicito un cambio de contraseña, por motivo de olvido y hemos podido validar que fue usted quien lo solicito, por favor inserte una nueva contraseña y su confirmación.",
      "password_change_error": "Ocurrio un problema al cambiar la contraseña, intente de nuevo.",
      "password_change_successfully": "Su contraseña fue modificada correctamente",
      "password_confirm_field": "Confirmar Contraseña",
      "password_field": "Contraseña",
      "save_btn": "Cambiar contraseña",
      "title": "Solicitud de cambio de contraseña"
    },
    "register": {
      "address": "Dirección",
      "checkbox": "Registrarme e Iniciar sesión",
      "city": "Ciudad",
      "country": "País",
      "email": "Correo electrónico",
      "last_name": "Apellidos",
      "login_btn": "Ir a Iniciar sesión",
      "name": "Nombre",
      "passport": "CI o Pasaporte",
      "password": "Contraseña",
      "password_confirm": "Confirmar contraseña",
      "phone_numbre": "Télefono",
      "send_btn": "Registrarme",
      "title": "Registrarme"
    }
  },
  "mailer": {
    "email_validate": {
      "email_btn": "Validar coreo electrónico",
      "otp": "Usted proporcionó un correo electrónico para iniciar sesión en nuestro sistema y es necesario por su seguridad proporcionar el código OTP para validar que es usted.",
      "text": "Usted proporcionó un correo electrónico para iniciar sesión en nuestro sistema y es necesario validar que es un correo electrónico real",
      "title": "Estimado(a) %{user}"
    },
    "password_change": {
      "reset_btn": "Recuperar contraseña",
      "text": "Le enviamos este correo porque usted solicito un cambio de contraseña, para realizar dicha acción acceda a la siguiente URL",
      "title": "Estimado(a) %{user}"
    }
  },
  "main": {
    "body": {
      "catalog": {
        "add_to_cart": "Adicionar al carrito",
        "assistance": "Asistencia en línea",
        "cancellation_time": "Tiempo de antelación para cancelar: %{days} días",
        "description": "Descripción",
        "from": "Desde",
        "no_available": "No disponible",
        "other_products": "Otros productos que puedan ser de tu interes",
        "price_tag": "Precio referencial desde: %{price} EUR",
        "rent_btn": "Reservar",
        "reservation_time": "Tiempo de antelación para reservar: %{days} días",
        "title": "Catalogo de productos"
      },
      "read_more": "Leer más..."
    },
    "cookies_box": {
      "button": "Estoy de acuerdo",
      "description": "Almacenamos datos temporalmente para mejorar su experiencia de navegación y recomendarle contenido de interés. Al utilizar nuestros servicios, aceptas dicho seguimiento.",
      "title": "Este sitio web usa cookies"
    },
    "header": {
      "admin": "Administración",
      "check_reservation": {
        "button": "Chequear",
        "email": "Correo electrónico",
        "no_reference": "No. de referencia",
        "title": "Chequear reserva"
      },
      "commercial": "Administración comercial",
      "credit": "Fondo revolvente",
      "editor_agency": "Editar Agencia",
      "editor_agency_mask_price": "Mascara de precios",
      "editor_data_agency": "Editar Datos de Agencia",
      "home": "Inicio",
      "login": "Acceder",
      "logout": "Salir",
      "profile": "Mi perfil",
      "register": "Registrarse",
      "reservation_request": "Solicitud",
      "shopping_cart": {
        "accept_btn": "Continuar",
        "cancel_btn": "Cancelar",
        "category": "Categoría",
        "destiny": "Destino",
        "drop_date": "Fecha de entrega",
        "pick_date": "Fecha de recogida",
        "price": "Precio",
        "time_elapse": "Tiempo restante",
        "title": "Producto en carrito"
      },
      "tickets_external": "Vouchers Externos",
      "transfer": "Traslados",
      "voucher": "Voucher"
    }
  },
  "noscript": {
    "button": "Recargar",
    "text": "Este sitio web usa javascript, revise si su navegador soporta el uso de javascript o si por algún motivo desactivo el uso de los mismos por favor activelo, para poder continuar",
    "title": "Este sitio usa javascript"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 3,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": "mil millones",
          "million": {
            "one": "millón",
            "other": "millones"
          },
          "quadrillion": "mil billones",
          "thousand": "mil",
          "trillion": {
            "one": "billón",
            "other": "billones"
          },
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 3,
        "significant": true,
        "strip_insignificant_zeros": true
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "Byte",
            "other": "Bytes"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n %"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "pre_reservations": {
    "base_price": "Reserva",
    "calculated_price": "Calculando precio...",
    "category": "Categoría",
    "days": "Días de reserva",
    "info": "* Se aplicará tasa de cambio según moneda de pago",
    "initial_gas": "Servicio de habilitado de combustible",
    "price_drop_off": "Entrega en otra oficina",
    "price_hire_point": "Suplemento de oficina",
    "product_description": "Descripción del producto",
    "total_price": "Total",
    "total_price_driver": "Chófer adicional",
    "total_price_insurance": "Relevo de responsabilidad",
    "total_supplement_insurance": "Suplemento de Edad"
  },
  "privacy_policy": {
    "title": "Política de Privacidad y Uso de Cookies"
  },
  "profile": {
    "my_reservations": {
      "last_reservations": "%{count} últimas rentas",
      "price": "Precio",
      "reference": "No. Referencia",
      "status": "Estado",
      "title": "Mis reservaciones",
      "type": "Fecha"
    },
    "notifications": {
      "global_notifications": "Notificaciones globales",
      "my_notifications": "Mis notificaciones",
      "title": "Notificaciones"
    },
    "profile": {
      "address": "Dirección",
      "avatar": "Avatar",
      "avatar_info_edit": "JPG or PNG no mayor de 1MB",
      "city": "Ciudad",
      "country": "País",
      "details": "Detalles de la cuenta",
      "edit_btn": "Editar detalles de la cuenta",
      "email": "Correo electrónico (Para acceder al sitio)",
      "email_invalid": "Validar",
      "email_valid": "Validado",
      "important": "Importante!!!",
      "info": "Para correguir errores en el Nombre, Apellidos o Pasaporte, favor de ponerse en contacto con Comercial a traves del  <a href='mailto:%{email}?subject=Solicitud de Actualización de Datos del usuario: %{user}&body=<b>Datos a actualizar del usuario</b><ul> <li>Nombre:</li> <li>Apellidos:</li> <li>Pasaporte:</li> <li>Motivo de la actualización de los datos:</li> </ul><br><i>Una vez completado el proceso de actualización de los datos recibira un correo de confirmación</i>'>Email de soporte</a>",
      "name": "Nombre (Cómo aparecerá su nombre en el sitio)",
      "passport": "CI o Pasaporte",
      "phone": "Teléfono",
      "surname": "Apellidos",
      "title": "Perfil"
    },
    "profile_save_success": "Perfil modificado",
    "security": {
      "change_password": "Cambiar contraseña",
      "confirm_new_password": "Confirmar nueva contraseña",
      "new_password": "Nueva contraseña",
      "notice_password_change_error": "Contraseña anterior incorrecta",
      "notice_password_change_success": "Contraseña modificada",
      "old_password": "Contraseña anterior",
      "title": "Seguridad"
    }
  },
  "reservation": {
    "main": {
      "action_btn": {
        "finish": "Pagar",
        "next": "Siguiente",
        "prev": "Anterior"
      },
      "steps": {
        "four": "Datos del Pago",
        "one": "Conductor titular",
        "three": "Términos y condiciones",
        "two": "Datos extra"
      },
      "steps_body": {
        "four": {
          "checking_gateway": "Verificando estado de pasarela...",
          "payment_gateway": "Pasarela de pago en línea",
          "proccesing_pay": "Procesando datos...",
          "title": "Método de pago"
        },
        "one": {
          "address": "Dirección",
          "city": "Ciudad",
          "country": "País",
          "email": "Correo electrónico",
          "name": "Nombre(s)",
          "passport": "Pasaporte",
          "surname": "Apellidos"
        },
        "three": {
          "accept_terms": "Acepto los términos y condiciones"
        },
        "two": "Datos extras"
      },
      "title": "Datos de la reserva"
    },
    "side_bar": {
      "active_reservation": "Reserva",
      "add_product": "Adicionar producto",
      "add_product_mobile": "Adicionar",
      "adult": "Adulto",
      "adults": "Adultos",
      "amount": "Cantidad",
      "assistance": "Asistencia",
      "brand": "Marca",
      "cancel_reservation_btn": "Cancel shopping cart",
      "cancel_reservation_mobile_btn": "Cancel",
      "category": "Categoría",
      "children": "Niño",
      "children_age": "Edad del niño",
      "children_info": "Cuando la edad es 0, se considera que es un bebé de meses de nacido.",
      "childrens": "Niños",
      "childrens_age": "Edades de los niños",
      "confirm_cart": "Proceder al pago",
      "confirm_cart_mobile": "Pagar",
      "date": "Fecha",
      "dealer": "Sucursal",
      "delete_product": "Eliminar producto",
      "delete_product_mobile": "Eliminar",
      "departure_from": "Salida desde",
      "destiny": "Destino",
      "dropoff_date": "Fecha de entrega",
      "dropoff_date_hotel": "Fecha de salida",
      "dropoff_place": "Lugar de entrega",
      "dropoff_time": "Hora de entrega",
      "event_type": "Tipo de evento",
      "lang": "Idioma",
      "modality": "Modalidad",
      "model": "Modelo",
      "payment_method": "Método de pago",
      "person_amount": "Personas",
      "pickup_date": "Fecha de recogida",
      "pickup_date_hotel": "Fecha de entrada",
      "pickup_place": "Recogida en",
      "pickup_place_description": "Especifique lugar en que se encuentra ó Punto de recogida",
      "pickup_time": "Hora de recogida",
      "price": "Precio",
      "price_by_person": "Precio x persona",
      "product": "Producto",
      "room_count": "Cantidad de habitaciones",
      "room_for": "Para: %{adult} Adultos y %{childrens} niños",
      "time_elapse": "Tiempo restante",
      "total_price": "Total a pagar",
      "update_product": "Actualizar producto",
      "update_product_mobile": "Actualizar"
    }
  },
  "support": {
    "array": {
      "last_word_connector": " y ",
      "two_words_connector": " y ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "am",
    "formats": {
      "default": "%A, %-d de %B de %Y %H:%M:%S %z",
      "long": "%-d de %B de %Y %H:%M",
      "short": "%-d de %b %H:%M"
    },
    "pm": "pm"
  }
});
